import * as React from "react";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import LogsTable from "../components/Tables/LogsTable";
import PageTitles from "../components/Layout/PageTitles";

export default function Logs() {
  return (
    <>
      <PageTitles title={"View Logs"} />
      <Grid id="i" container spacing={3}>
        <Grid item xs={12}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <LogsTable />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
